import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { DangerButton } from '@grnhse/seedling/lib/birch/components/buttons';

const t = withLocalePrefix('talent_matching.bulk_actions.reject');

type Props = {
  openModal: () => void;
  selectionsHelper: SelectionsHelper;
  loading: boolean;
  canReject: boolean;
};

const RejectButton = ({
  openModal,
  selectionsHelper,
  loading,
  canReject,
}: Props) => {
  const isDisabled = selectionsHelper.noneSelected || !canReject || loading;
  const tooltipText = !canReject
    ? t('tooltip.cannot_reject')
    : selectionsHelper.noneSelected
    ? t('tooltip.none_selected')
    : null;

  return (
    <Tooltip label={tooltipText} ariaLabel={tooltipText || ''}>
      <DangerButton
        onClick={openModal}
        disabled={isDisabled}
        loading={loading}
        size="md"
      >
        {t('button', { count: selectionsHelper.totalSelected })}
      </DangerButton>
    </Tooltip>
  );
};

export default RejectButton;
